import { useEffect } from 'react';
import { isSupported, getPermission, requestPermission } from '../lib/notifications';

/**
 * Quietly request notification permission once after a delay.
 * Idempotent — only fires once when permission state is 'default'.
 */
export const useNotificationPrompt = (delayMs = 1500) => {
  useEffect(() => {
    if (!isSupported() || getPermission() !== 'default') return;
    const t = setTimeout(() => { requestPermission(); }, delayMs);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delayMs, isSupported, getPermission, requestPermission]);
};
